import ChildrenRenderer from 'day4-modules/es/blocks/core/ChildrenRenderers';
import NeedAuth from './NeedAuth';

NeedAuth.register = {
  isExpectChildren: true,
  ChildrenRenderer,
};

export default NeedAuth;
